import { SetUserPasswordRequest } from '@pages/set-password/models/set-user-password-request.interface';

const actionScope = '[Set Password]';

export class ValidateInvitation {
  static readonly type = `${actionScope} Validate Invitation`;
  constructor(public readonly invitationToken: string) {}
}

export class SetPassword {
  static readonly type = `${actionScope} Set Password`;
  constructor(public readonly request: SetUserPasswordRequest) {}
}

export class SwitchToExpiredLinkStep {
  static readonly type = `${actionScope} Switch To Expired Link Step`;
}
